import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { QRCodeComponent } from 'angularx-qrcode';
import { CardComponentModule, SharedModule } from 'lib-trend-core';
import { WaTemplateModule } from '../attendance/attendance-panel/attendance-panel-components/wa-template/wa-template.module';
import { ChatbotModule } from '../chatbot/chatbot.module';
import { DepartmentModule } from '../department/department.module';
import { ResponseModule } from '../response/response.module';
import { WhatsappSignupModule } from '../whatsapp-signup/whatsapp-signup.module';
import { ChannelAPIsComponent } from './channel-apis/channel-apis.component';
import { ChannelConfigCopilotComponent } from './channel-config/channel-config-copilot/channel-config-copilot.component';
import { CopilotModelSelectDialogComponent } from './channel-config/copilot-model-select-dialog/copilot-model-select-dialog.component';
import { ChannelConfigComponent } from './channel-config/channel-config.component';
import { ChannelHybridSessionComponent } from './channel-config/channel-hybrid-session/channel-hybrid-session.component';
import { ChannelVoipRamaisComponent } from './channel-config/channel-voip-ramais/channel-voip-ramais.component';
import { ChannelVoipRamalFormComponent } from './channel-config/channel-voip-ramais/ramal-form/channel-voip-ramal-form.component';
import { ChannelWebchatComponent } from './channel-config/channel-webchat/channel-webchat.component';
import { SettingsTemplateListModule } from './channel-config/settings-template-list/settings-template-list.module';
import { ChannelEditComponent } from './channel-edit/channel-edit.component';
import { ChannelFormComponent } from './channel-form/channel-form.component';
import { ChannelRedirectInstagramComponent } from './channel-redirect-instagram/channel-redirect-instagram.component';
import { ChannelRoutingModule } from './channel-routing.module';
import { HealthMetaUsageCardComponent } from './channel-view/channel-health/cards/health-meta-usage-card.component';
import { HealthHybridCardComponent } from './channel-view/channel-health/cards/health-hybrid-card.component';
import { ChannelHealthDashboardComponent } from './channel-view/channel-health/channel-health-dashboard.component';
import { HealthProfileTabComponent } from './channel-view/channel-health/tabs/health-profile-tab.component';
import { HealthQualityTabComponent } from './channel-view/channel-health/tabs/health-quality-tab.component';
import { HealthStatusTabComponent } from './channel-view/channel-health/tabs/health-status-tab.component';
import { HealthSummaryTabComponent } from './channel-view/channel-health/tabs/health-summary-tab.component';
import { ChannelViewComponent } from './channel-view/channel-view.component';
import { ChannelComponent } from './channel.component';
import { TemplateButtonRowComponent } from './template-builder/template-button-row.component';
import { TemplateFieldsComponent } from './template-builder/template-fields.component';
import { TemplateBuilderComponent } from './template-builder/template-builder.component';
import { TemplatePreviewComponent } from './template-builder/template-preview.component';
import { WebchatLogoUploadComponent } from './webchat-logo-upload/webchat-logo-upload.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    CardComponentModule,
    QRCodeComponent,
    ChannelRoutingModule,
    WhatsappSignupModule,
    NgxChartsModule,
    ChatbotModule,
    ResponseModule,
    DepartmentModule,
    WaTemplateModule,
    // Declared in its own module so CampaignModule can render the same list without importing
    // ChannelModule (and with it, the channel routes).
    SettingsTemplateListModule,
    // SharedModule imports PickerModule but does not re-export it, so the emoji picker of the
    // template body needs it here — the same way response.module.ts does.
    PickerModule,
    DragDropModule,
  ],
  declarations: [
    ChannelComponent,
    ChannelFormComponent,
    ChannelConfigComponent,
    ChannelHybridSessionComponent,
    ChannelViewComponent,
    ChannelHealthDashboardComponent,
    HealthSummaryTabComponent,
    HealthStatusTabComponent,
    HealthQualityTabComponent,
    HealthProfileTabComponent,
    HealthMetaUsageCardComponent,
    HealthHybridCardComponent,
    ChannelEditComponent,
    ChannelAPIsComponent,
    ChannelRedirectInstagramComponent,
    ChannelConfigCopilotComponent,
    CopilotModelSelectDialogComponent,
    ChannelVoipRamaisComponent,
    ChannelVoipRamalFormComponent,
    ChannelWebchatComponent,
    TemplateBuilderComponent,
    TemplateFieldsComponent,
    TemplateButtonRowComponent,
    TemplatePreviewComponent,
    WebchatLogoUploadComponent,
  ],
  exports: [
    ChannelComponent,
    ChannelFormComponent,
    ChannelConfigComponent,
    ChannelViewComponent,
    ChannelEditComponent,
    ChannelAPIsComponent,
    SettingsTemplateListModule,
    ChannelRedirectInstagramComponent,
    ChannelConfigCopilotComponent,
  ],
  providers: [],
  schemas: []
})
export class ChannelModule { }
